import { lazy, Suspense, useEffect, useState } from "react";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter
} from "react-router-dom";
import style from "./App.module.css";
import Layout from "./componets/layout/layout";
import auth from "./services/auth";
import axios from "axios";
import { config } from "./config";
import { BookForm } from "./page/manage_book/BookForm";
import ProtectedRoute from "./componets/ProtectedRoute";
import IssuedBooksHistory from "./page/Users/IssuedBooksHistory";
const AllBooks = lazy(() => import("./page/All_book/AllBooks"));
const IssueBook = lazy(() => import("./page/Issuebook/IssueBook"));
const Login = lazy(() => import("./page/Login/login"));
const Users = lazy(() => import("./page/Users/Users"));
const UserForm = lazy(() => import("./page/Users/UserForm"));
const ImportBooks = lazy(() => import("./page/import_books_excel/ImportBooks"));
const ManageBook = lazy(() => import("./page/manage_book/ManageBook"));
const ManageBook2 = lazy(() => import("./page/manage_book/ManageBook2"));
const Managerack = lazy(() => import("./page/manage_rack/managerack"));
// import Allbook from "./page/All_book/All_book";
const Upcoming_books_return = lazy(() =>
  import("./page/upcoming_book_return/upcoming_book_return")
);
// import RackList from "./page/manage_rack/racklist";
const Department = lazy(() => import("./page/manage_dept/Department"));
const Subdepartment = lazy(() => import("./page/Sub_department/Sub_dept"));
const ShareBooks = lazy(() => import("./page/book_template/Share_Books"));
const ShareBooksWithoutSummary = lazy(() =>
  import("./page/book_template/Share_books_Without_Summary")
);
// import MenuBar from "./componets/menubar/menubar";
const UsersList = lazy(() => import("./page/Users/UsersList"));
const ErrorPage = lazy(() => import("./page/ErrorPage"));
const ReturnBook = lazy(() => import("./page/return_book/return_book"));
const IssuedBooks = lazy(() => import("./page/Users/IssuedBooks"));
// UPDATE jain_library.fetchbooktemplate3 SET book_pages = pages WHERE book_pages='';
// const data = SELECT book_pages FROM jain_library.fetchbooktemplate3
// const rows = book_pages.rows
// rows.map((data)=>{data.include("+")})
// book_pages is a second input which we want to show in share books and share books without summary page

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/admin/" />,
  },
  {
    path: "/admin/login",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <Login />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
  },

  //   {
  //   path: "/admin",
  //   element: <ProtectedRoute />, // wrap it
  //   children: [

  //     {
  //       path: "/admin",
  //       element: <Layout />,
  //       children: [
  //         {
  //           path: "/admin/",
  //           element: (
  //             <Suspense fallback={<div>Loading...</div>}>
  //               <IssueBook />
  //             </Suspense>
  //           ),
  //         },
  //         // ...rest of the admin children routes
  //       ],
  //     },
  //   ],
  // }

  {
    path: "/admin",
    element: <ProtectedRoute />,
    children: [
      {
        path: "/admin",
        element: <Layout />,
        errorElement: <ErrorPage />,
        children: [
          {
            path: "/admin/",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <IssueBook />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/users",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Users />
              </Suspense>
            ),
            errorElement: <ErrorPage />,

            children: [
              {
                path: "/admin/users/",
                element: (
                  <Suspense fallback={<div>Loading...</div>}>
                    <UsersList />
                  </Suspense>
                ),
                errorElement: <ErrorPage />,
              },
              {
                path: "/admin/users/new_user",
                element: (
                  <Suspense fallback={<div>Loading...</div>}>
                    <UserForm />
                  </Suspense>
                ),
                errorElement: <ErrorPage />,
              },
              {
                path: "/admin/users/update_user/:id",
                element: (
                  <Suspense fallback={<div>Loading...</div>}>
                    <UserForm />
                  </Suspense>
                ),
                errorElement: <ErrorPage />,
              },
            ],
          },
          {
            path: "/admin/managebook",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <BookForm />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
            children: [
              {
                path: "/admin/managebook",
                element: (
                  <Suspense fallback={<div>Loading...</div>}>
                    <ManageBook2 />
                  </Suspense>
                ),
                errorElement: <ErrorPage />,
              },
              {
                path: "/admin/managebook/:id",
                element: (
                  <Suspense fallback={<div>Loading...</div>}>
                    <ManageBook2 />
                  </Suspense>
                ),
                errorElement: <ErrorPage />,
              },
              {
                path: "/admin/managebook/view_all_books",
                element: (
                  <Suspense fallback={<div>Loading...</div>}>
                    <AllBooks />
                  </Suspense>
                ),
                errorElement: <ErrorPage />,
              },
            ],
          },
          {
            path: "/admin/importbooks",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ImportBooks />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/department",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Department />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/subdepartment",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Subdepartment />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/managerack",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Managerack />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/upcoming_books_return",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Upcoming_books_return />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/books",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ShareBooks />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/books_without_summary",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ShareBooksWithoutSummary />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/return_book",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ReturnBook />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/users/issued_books/:id",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <IssuedBooks />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: "/admin/users/issued_books_history/:id",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <IssuedBooksHistory />
              </Suspense>
            ),
            errorElement: <ErrorPage />,
          },
        ],
      },
    ]
  }
]);

function App() {
  const [isAuthenticated, setAuthenticate] = useState(false);

  async function check_token(token) {
    let payload = {
      fn: "common_fn",
      se: "to_vi",
      data: { token: token },
    };

    let reqbody = JSON.stringify(payload);
    try {
      const response = await axios.post(
        `${config.apiBaseURL}/common`,
        { payload: reqbody },
        { headers: { "Content-Type": "application/json" }, mode: "no-cors" }
      );

      return response;
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const isAuth = auth.getAuth();

    if (isAuth) {
      check_token(isAuth).then((res) => {
        if (res.data.status === 0) {
          setAuthenticate(true);
        } else {
          localStorage.removeItem("token");
        }
      });
    } else {
      setAuthenticate(false);
    }

  }, []);

  return (
    <div className={style.App}>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
